import { loadingAnimationMixin } from '@/styles/mixins/loading-mixin'
import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  title: ({ spacing }) => css`
    margin-bottom: ${spacing.xxs};
  `,

  consultationCard: ({ spacing, grid }) => css`
    margin-top: ${spacing.sm};
    flex-wrap: wrap;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: ${spacing.xs};
    margin-bottom: ${spacing.sm};
    @media (max-width: ${grid.breakpoint.sm}) {
      margin-bottom: ${spacing.xs};
    }
  `,

  skeletonWrapper: ({ spacing }) => css`
    margin-top: ${spacing.xl};
  `,

  skeletonTitle: ({ spacing, border, colors }) => css`
    display: flex;
    width: 156px;
    height: 28px;
    margin-bottom: ${spacing.sm};
    border-radius: ${border.radius.lg};
    ${loadingAnimationMixin(colors.neutral[100], colors.neutral[200])};
  `,

  skeletonCardWrapper: ({ spacing }) => css`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${spacing.xs};
    flex-wrap: wrap;

    @media (min-width: ${spacing.sm}) {
      grid-template-columns: 1fr 1fr;
    }

    @media (min-width: ${spacing.lg}) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  `,

  skeletonCard: ({ border, colors }) => css`
    display: flex;
    width: 100%;
    height: 177px;
    border-radius: ${border.radius.lg};
    ${loadingAnimationMixin(colors.neutral[100], colors.neutral[200])};
  `,
})

export { useStyles }
